import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-formcontrol-subdocument',
  template: require('./formcontrol-subdocument.component.html'),
  styles: [require('./formcontrol-subdocument.component.scss')],
})
export class FormcontrolSubdocumentComponent {
  @Input() displayName: string;
  @Input() value: string;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/admin/shared/formcontrol-subdocument/formcontrol-subdocument.component.ts